// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlusCircleOutlinedSvg from "@fishx/icons-svg/es/asn/PlusCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var PlusCircleOutlined = function PlusCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlusCircleOutlinedSvg
  }));
};

PlusCircleOutlined.displayName = 'PlusCircleOutlined';
export default React.forwardRef(PlusCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PlusCircleOutlined.js
// module id = 3818
// module chunks = 0